import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class KudosService {
  constructor(private http: HttpClient) {}

  // dropdown

  selectCateg(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/kudos/select_category`);
  }

  selectsubCateg(categID): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/kudos/select_award_subcategory/${categID}`
    );
  }

  // category get

  awardCategGet(data): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/kudos/get_awrd_cat?page=${data.page}&limit=${data.limit}&cat_name=${data.cat_name}`
    );
  }

  editCategStatus(stat, CategID): Observable<any> {
    const option = {
      status: stat,
      cat_id: CategID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/kudos/edit_awrd_cat_status_action`,
      options
    );
  }

  editCateg(CategID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/kudos/edit_awrd_cat/` + CategID
    );
  }

  deleteCateg(CategID): Observable<any> {
    return this.http.post(`${environment.apiUrl}/kudos/delete_awrd_cat`, {
      cat_id: CategID,
    });
  }

  addCateg(data: FormData, CategID): Observable<any> {
    if (!CategID) {
      return this.http.post<any>(
        `${environment.apiUrl}/kudos/add_awrd_cat_action`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/kudos/edit_awrd_cat_action`,
        data
      );
    }
  }

  // SUBCATEG

  awardsubCategGet(data): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/kudos/get_awrd_subcat?page=${data.page}&limit=${data.limit}&cat_id=${data.cat_id}`
    );
  }

  editsubCategStatus(stat, CategID): Observable<any> {
    const option = {
      status: stat,
      subcat_id: CategID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/kudos/edit_awrd_subcat_status_action`,
      options
    );
  }

  editsubCateg(CategID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/kudos/edit_awrd_subcat/` + CategID
    );
  }

  deletesubCateg(CategID): Observable<any> {
    return this.http.post(`${environment.apiUrl}/kudos/delete_awrd_subcat`, {
      subcat_id: CategID,
    });
  }

  addsubCateg(data: FormData, CategID): Observable<any> {
    if (!CategID) {
      return this.http.post<any>(
        `${environment.apiUrl}/kudos/add_awrd_subcat_action`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/kudos/edit_awrd_subcat_action`,
        data
      );
    }
  }

  // Create Award

  awardGet(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/kudos/get_award`, {
      params: param,
    });
  }


  awardCertificate(data: any): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/kudos/generate_certificate`,
      data
    );
  }

  editAwardStatus(stat, awardID): Observable<any> {
    const option = {
      status: stat,
      awrd_id: awardID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/kudos/edit_award_status_action`,
      options
    );
  }

  editAward(awardID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/kudos/edit_award_action/` + awardID
    );
  }

  deleteAward(awardID): Observable<any> {
    return this.http.post(`${environment.apiUrl}/kudos/delete_award`, {
      awrd_id: awardID,
    });
  }

  addAward(data: FormData, awardID): Observable<any> {
    if (!awardID) {
      return this.http.post<any>(
        `${environment.apiUrl}/kudos/add_award_action`,
        data
      );
    } else {
      return this.http.post<any>(
        `${environment.apiUrl}/kudos/edit_award_action`,
        data
      );
    }
  }

  // kudos Excel
  excelAwardGet(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/kudos/get_award_on_excel`,
      { params: param }
    );
  }

  // sos
  sosService(data: FormData): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/kudos/add_contact_onservice`,
      data
    );
  }

  getSos(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/kudos/get_sos`, {
      params: param,
    });
  }

  sosDump(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/kudos/get_sos_report`);
  }

  sosRemark(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/kudos/update_remark_on_sos`,
      data
    );
  }

  // ID card
  getIDcards(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/get_master_emp_id_card`, {
      params: param,
    });
  }

  idCardDump(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/mis-reports/emp_idcard_report`,
      data
    );
  }

  imageZip(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/get_all_empidcard_inzip`,
      data
    );
  }

  idCardStages(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/emp_stage_dropdown`);
  }

  updateStatusIDCard(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/spoc_idcard_status_update`,
      data
    );
  }

  bulkStatusIDCard(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/change_empidcard_status`,
      data
    );
  }

  // microLoan
  microLoanRequest(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/kudos/add_loan_request`,
      data
    );
  }
  visitingCardStages(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/visiting_stage_dropdown`);
  }

  getVisitingcards(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(`${environment.apiUrl}/get_master_emp_visiting_card`, {
      params: param,
    });
  }

  updateStatusVisitingCard(data): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/visiting_card_status_update`,data);
  }
  
  visitingCardDump(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/mis-reports/emp_visiting_card_report`);
  }

  regenCertificate(data: any): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/kudos/re_generate_certificate`,
      data
    );
  }

}
